import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.375 4.375L10.625 10.625",
      stroke: "#333333",
      "stroke-width": "1.25",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.375 10.625L10.625 4.375",
      stroke: "#333333",
      "stroke-width": "1.25",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }